import Joi from "joi";

export const vendorSchema = Joi.object({
  name: Joi.string().min(2).label("Name"),
  address: Joi.string().min(2).label("Address"),
  contact: Joi.string().min(2).label("Contact"),
  notes: Joi.string().min(2).label("Notes"),
  businessNo: Joi.string().min(2).label("Business No"),
  taxId: Joi.string().min(2).label("Tax"),
  vendorStatusId: Joi.string().min(2).label("Vendor Status"),
});
